import { FEATURES } from '/src/features/_global/constants';

export const TRAFFIC_ANALYSIS_PERMISSIONS = {
  [FEATURES.TRAFFIC_ANALYSIS]: ({ capabilities }) => ({
    navigate: capabilities?.trafficAnalysis.permissions.nav,
    view: capabilities?.trafficAnalysis.permissions.view,
  }),
};
